import Table from '@/components/Table/Table.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default ({Model, prop, ...props}) => {
    const map = useMapContext()
    const model = new Model(map)
    const title = model.name(null, prop)

    return {
        title,
        dataIndex: prop,
        component: <Table.ViewText />,
        ...props
    }
}
